import { render } from "./BookCategory.vue?vue&type=template&id=8b331012&scoped=true"
import script from "./BookCategory.vue?vue&type=script&lang=js"
export * from "./BookCategory.vue?vue&type=script&lang=js"

import "./BookCategory.vue?vue&type=style&index=0&id=8b331012&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b331012"]])

export default __exports__